import { Color, Spacing, Text as TextComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const BodyWrapper = styled.div`
  display: flex;
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  padding: ${Spacing.S16} ${Spacing.S16} 0;
  background-color: ${Color.Purple50};
`

export const ContentContainer = styled.div`
  width: 596px;
  padding: ${Spacing.S40} ${Spacing.S32} ${Spacing.S32};
`

export const BulletList = styled.div`
  display: flex;
  flex-direction: column;
`

export const Text = styled(TextComponent)`
  cursor: pointer;
`

export const BenefitItem = styled.div`
  display: flex;
`

export const IconContainer = styled.div`
  margin-right: ${Spacing.S6};
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`
